import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { map } from "lit/directives/map.js";
import "../resultcard/result-card";
import "../paging/paging";
import { ListStyles } from "../liststylebuttons/liststylebuttons";

@customElement("learningcenter-results")
export class LearningCenterResults extends LitElement {
  @property()
  accessor dictionary: any = {};

  @property()
  accessor culture: string = "";

  createRenderRoot() {
    return this;
  }

  apiUrl = "/api/LearningCenter/articles?";
  items: Iterable<any> = []; // Changed from Set to Array
  currentPage = 0;
  totalPages = 0;
  currentListStyle = ListStyles.GRID_BIG; //Default layout
  pageSize = 12;
  usesFallback = false; // Flag to indicate if fallback to English was used

  constructor() {
    super();
    this.items = [];
    this.currentPage = 0;
    this.totalPages = 0;
    this.usesFallback = false;
  }

  connectedCallback() {
    super.connectedCallback();
    this.fetchData();
  }

  async fetchData() {
    this.usesFallback = false;
    try {
      
      const urlParams = new URLSearchParams(window.location.search);

      const query = urlParams.get("query") || "";
      const includeCategories = urlParams.getAll("category") || [];
      const includeTags = urlParams.getAll("tag") || [];

      let response = await fetch(this.apiUrl + `cultureName=${this.culture}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query: query,
          cultureName: this.culture,
          includeCategories: includeCategories.map(Number),
          includeTags: includeTags.map(Number),
          page: this.currentPage,
          pageSize: this.pageSize,
        }),
      });
      let data = await response.json();

      //Fallback to English if no results found
      if (data.totalHits === 0) {
        this.usesFallback = true;
        response = await fetch(this.apiUrl + `cultureName=en-GB`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            query: query,
            cultureName: 'en-GB',
            includeCategories: includeCategories.map(Number),
            includeTags: includeTags.map(Number),
            page: this.currentPage,
            pageSize: this.pageSize,
          }),
        });
        data = await response.json();
      }

      this.items = data.hits;
      this.totalPages = data.totalPages;
      this.items = [...data.hits];
      this.requestUpdate();
      console.log(this.items);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  handlePageChange(event: CustomEvent) {
    const element = document.getElementById("resultlist");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    this.currentPage = event.detail.currentPage;
    console.log("Parent received page change:", this.currentPage);
    this.fetchData();
  }

  handleLayoutChange(event: CustomEvent) {
    console.log(
      "Parent received layout change:",
      event.detail.currentListStyle
    );
    const currentListStyle = event.detail.currentListStyle;
    this.currentListStyle = currentListStyle;

    this.requestUpdate();
  }

  renderListItems() {
    let gridClasses = "grid grid-cols-24" + " ";
    switch (this.currentListStyle) {
      case ListStyles.LIST:
        gridClasses += "gap-2 md:gap-4";
        break;
      case ListStyles.GRID_SMALL:
        gridClasses += "gap-2 md:gap-6";
        break;
      case ListStyles.GRID_BIG:
      default:
        gridClasses += "gap-2 md:gap-6";
        break;
    }

    if (this.totalPages == 0) {
      return html`<div class="w-full text-center text-dark-blue-100 text-h4">
        ${JSON.parse(this.dictionary)["noresults"] ?? ""}
      </div>`;
    }
    return html`<div class="${gridClasses} w-full">
      ${map(
        this.items,
        (item) =>
          html`<result-card
            .url="${item.url}"
            .title="${item.title}"
            .imageUrl="${item.imageUrl}"
            .summary="${item.summary}"
            .tag="${item.category}"
            .listStyle="${this.currentListStyle}"
            .dictionary="${this.dictionary}"
            .newWindow="${this.usesFallback}"
          ></result-card>`
      )}
    </div>`;
  }

  render() {
    return html`
      <div class="bg-medium-grey-10 md:bg-transparent">
        <div>
          <list-styles
            .currentListStyle="${this.currentListStyle}"
            @layout-change="${this.handleLayoutChange}"
            class="hidden md:block mb-15"
          ></list-styles>
          <div
            id="resultlist"
            class="list
            scroll-mt-[74px] md:scroll-mt-[90px]
            max-w-site-maxwidth mx-auto site-gutter w-full"
          >
            ${this.renderListItems()}
          </div>

          <paging-element
            .currentPage="${this.currentPage}"
            .totalPages="${this.totalPages}"
            .dictionary="${this.dictionary}"
            @page-change="${this.handlePageChange}"
            class="block mt-15"
          ></paging-element>
        </div>
      </div>
    `;
  }
}
